import { DataSource } from '@client/core/data/concerns/data-source';
import { fromJson } from '@client/core/data/concerns/parses-from-json';
import { HttpResponse } from '@client/core/http/types';
import { OgMetaFields } from '@client/features/og-meta-fields/models/og-meta-fields';

export class OgMetaFieldsDataSource extends DataSource {
  async scrapeOgMetaByUrl(url: string): Promise<OgMetaFields> {
    const response = await this.httpClient.post<HttpResponse<OgMetaFields>>('/open-graph/scrape-og-meta', { url });

    return fromJson(OgMetaFields, response.data.data);
  }
}
